import { memo } from "react";

import Button from "@/common/Button";
import { logAnalyticsEvent, setAnalyticsUserProperties } from "@/constants/amplitude";
import { WebEventProps, WebEventTypes } from "@/constants/event";
import { QuestionTypes } from "@/constants/questionsIds";
import { Question } from "@/types/question";

interface QuestionProps {
    question: Question<QuestionTypes.YesNo>;
    handleNext(answ: unknown): void;
    isActive: boolean;
}

export const YesNo = memo<QuestionProps>(
    ({ isActive, question: { id, title, subtitle, img, answers, event }, handleNext }) => {
        const goToNextQuestion = (ansId: string) => {
            handleNext({ [id]: ansId });
            logAnalyticsEvent(WebEventTypes.RESULT_EVENT, {
                [WebEventProps.SCREEN]: event,
                result: ansId,
            });
            setAnalyticsUserProperties({ [id]: ansId });
        };

        const handleContinue = (ansId: string) => () => {
            goToNextQuestion(ansId);
        };

        return (
            <div className="flex h-full flex-col justify-between gap-6 overflow-hidden pb-6 pt-2">
                <div className="grid gap-5">
                    <h1 className="whitespace-pre-wrap text-center text-zing-24-32 font-semibold">
                        {title}
                    </h1>
                    <div className="relative pr-5">
                        <img src={img} className="" alt="" />
                        <div className="absolute -bottom-10 right-0 box-content w-52 rounded-3xl border-4 border-white bg-zing-warm-tangerine-400 p-6 text-zing-18-26 font-semibold text-white">
                            {subtitle}
                        </div>
                    </div>
                </div>
                <div className="flex gap-2.5">
                    {answers.map(({ id, text, icon: Icon }) => (
                        <Button
                            key={id}
                            isDisabled={!isActive}
                            className="flex flex-row justify-center px-6 py-4 female:bg-zing-neutral-cool-grey-200 female:text-black"
                            onClick={handleContinue(id)}
                        >
                            {Icon && <Icon />} {text}
                        </Button>
                    ))}
                </div>
            </div>
        );
    }
);
